import { useState } from 'react';
import track from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import { SearchFieldWrapper, ResultWrapper } from './styled';
import { Textfield } from '@simplywallst/ui-core';
import { SearchIcon } from '@/components/Search';
import loadable from '@loadable/component';
import { Modal } from '@simplywallst/ui-core';
import { RouterLink } from '@/utilities/redux-first-router.export';
import { useDispatch } from 'react-redux';
import { cacheResults } from '@/components/Search/redux/routines';

const AlgoliaSearch = loadable(
  () => import('@/components/Search/components/AlgoliaSearch')
);

interface Props {
  placeholder?: string;
  onAdd?: (id: string) => void;
}

const MobileSearch = (props: Props) => {
  const [selectedCompany, setSelectedCompany] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState('');
  const [queue, setQueue] = useState('');
  const dispatch = useDispatch();
  function handleClick() {
    if (typeof props.onAdd === 'function') {
      props.onAdd(selectedCompany);
    }
    setQueue('');
    setQuery('');
  }
  return (
    <>
      <SearchFieldWrapper>
        <Textfield
          name="search-and-add-holding"
          type="text"
          readOnly={true}
          placeholder={props.placeholder || 'Search e.g. Apple'}
          prefix={<SearchIcon />}
          value={queue}
          onFocus={() => {
            setShowSearch(true);
          }}
        />
      </SearchFieldWrapper>
      {props.onAdd && (
        <Button
          styleType="louderLarge"
          displayMdDown="block"
          disabled={false}
          isLoading={false}
          onClick={handleClick}
          data-cy-id="add-button"
        >
          Add
        </Button>
      )}

      {showSearch && (
        <Modal isNaked onSecondaryClick={() => setShowSearch(false)}>
          <AlgoliaSearch
            onClose={() => setShowSearch(false)}
            onSearchResult={(results, query) => {
              setQuery(query);
              dispatch(cacheResults.trigger(results));
            }}
            onReset={() => setQueue('')}
            query={query}
            primaryWrapper={(child, result) => {
              return props.onAdd ? (
                <ResultWrapper
                  onClick={() => {
                    setSelectedCompany(result.uniqueSymbol);
                    setShowSearch(false);
                    setQueue(result.name);
                  }}
                >
                  {child}
                </ResultWrapper>
              ) : (
                <RouterLink to={result.canonicalUrl} tabIndex={0}>
                  {child}
                </RouterLink>
              );
            }}
            secondaryWrapper={(child, listing) => {
              return props.onAdd ? (
                <ResultWrapper
                  onClick={() => {
                    setSelectedCompany(listing.uniqueSymbol);
                    setShowSearch(false);
                    setQueue(listing.uniqueSymbol);
                  }}
                >
                  {child}
                </ResultWrapper>
              ) : (
                <RouterLink to={listing.canonicalUrl} tabIndex={0}>
                  {child}
                </RouterLink>
              );
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default track({
  type: 'track',
  subject: 'holdings',
})(MobileSearch) as typeof MobileSearch;
